import styles, { stylesheet } from './LegacyLiveChat.scss'
import disabledIcon from '../../assets/images/disabled_icon.svg'
import { withTranslation } from 'react-i18next'
import { Typography, Button, Row, ResponsiveImage, Box } from '@vp/swan'
import { useStyles } from '@vp/ubik-context'

const DisabledLiveChat = (props) => {
  const { t } = props
  const lng = props.locale.toLowerCase().replace('-', '_')
  useStyles(stylesheet)
  return (
    <Box paddingRight="2" className={styles.livechatColumnContainer}>
      <Row>
        <div style={{ display: 'flex' }}>
          <Typography component="h3" fontSize="x2large">
            {t(`${props.tenant}:chat.title`, { lng })}
          </Typography>
        </div>
      </Row>
      <Row pt="5">
        <div>
          <ResponsiveImage role="presentation" aspectratio="1" src={disabledIcon} alt="" width="12px" />
          <Typography component="span" fontSize="large" style={{ fontWeight: '700' }} ml="3">
            {t(`${props.tenant}:pre_footer.links.live_chat.offline.status`, '', { lng })}
          </Typography>
        </div>
      </Row>
      <Row pt="5">
        <div>
          <Typography> {t(`${props.tenant}:chat.buttons.chat_offline.description`, { lng })} </Typography>
        </div>
      </Row>
      <Row pt="5">
        <Button disabled skin="holiday-white" size="standard" type="button" name="chat_offline" value="chat_offline">
          {t(`${props.tenant}:chat.buttons.chat_offline.title`, { lng })}
        </Button>
      </Row>
    </Box>
  )
}
export default withTranslation()(DisabledLiveChat)
